import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "atu-bg_image"
};
const _hoisted_2 = {
  class: "atu-banner"
};
const _hoisted_3 = {
  class: "best-value"
};
const _hoisted_4 = {
  class: "banner-description"
};
const _hoisted_5 = {
  class: "banner-description-col"
};
const _hoisted_6 = {
  class: "banner-description-entry"
};
const _hoisted_7 = {
  class: "banner-description-entry"
};
const _hoisted_8 = {
  class: "banner-description-entry"
};
const _hoisted_9 = {
  class: "banner-description-col"
};
const _hoisted_10 = {
  class: "banner-description-entry"
};
const _hoisted_11 = {
  class: "banner-description-entry"
};
const _hoisted_12 = {
  class: "banner-description-entry"
};
const _hoisted_13 = {
  class: "cta-container"
};
const _hoisted_14 = {
  class: "button-container"
};
import { inject } from 'vue';
import { CircleCheck, Right } from '@element-plus/icons-vue';
import { Diamond } from '../../assets/SVGs/AutoTuneIconLib';
import WpElButton from '@/components/WpComponents/WpElButton.vue';
export default {
  __name: 'NavBarProductATUBanner',
  setup(__props) {
    const user = inject('user');
    const closeNavBar = inject('closeNavBar', () => {});
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(Diamond), {
        class: "el-icon"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "Best Value", -1))]), _cache[10] || (_cache[10] = _createElementVNode("h6", {
        class: "banner-title"
      }, " Everything in One Place ", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "5 AutoTune editions & AutoKey", -1))]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "5 Ai-powered vocal mixing plugins", -1))]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "12 creative vocal effects", -1))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[4] || (_cache[4] = _createElementVNode("span", null, "Immediate access to new releases", -1))]), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[5] || (_cache[5] = _createElementVNode("span", null, "Industry insider recording templates", -1))]), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(CircleCheck), {
        class: "el-icon",
        style: {
          "color": "var(--el-color-primary)"
        }
      }), _cache[6] || (_cache[6] = _createElementVNode("span", null, "Try for free and cancel any time", -1))])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(WpElButton, {
        type: "primary",
        size: "large",
        action: "go_to",
        value: {
          name: 'Subscriptions',
          params: {
            slug: 'unlimited'
          }
        },
        onClick: _unref(closeNavBar)
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" Subscribe Now ")])),
        _: 1
      }, 8, ["onClick"]), !(_unref(user).isSubscriber || _unref(user).isTrialUser || _unref(user).wasTrialer) ? (_openBlock(), _createBlock(WpElButton, {
        key: 0,
        type: "primary",
        size: "large",
        class: "gray-base",
        action: "add_to_cart",
        value: "auto-tune-unlimited-monthly-14d-free",
        onClick: _unref(closeNavBar)
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" Try for Free ")])),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
        class: "learn-more-link",
        to: {
          name: 'SubscriptionsSubnav',
          params: {
            slug: 'unlimited',
            subnav_slug: 'overview'
          }
        },
        onClick: _unref(closeNavBar)
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("span", null, "Learn More", -1)), _createVNode(_component_el_icon, {
          size: 24
        }, {
          default: _withCtx(() => [_createVNode(_unref(Right))]),
          _: 1
        })]),
        _: 1
      }, 8, ["onClick"])])])]);
    };
  }
};